export interface SendMemberInviteInput {
  email: string;
  firstName: string;
  lastName: string;
  scope: string;
  scopeId: string;
  roleName: string;
  type: string;
}
